import Vue from 'vue'

Vue.component('i-observer', () => import('@/components/GraphicComponents/IObserver.vue'))
Vue.component('d-text', () => import('@/components/GraphicComponents/DText.vue'))
Vue.component('d-grid', () => import('@/components/GraphicComponents/DGrid.vue'))
Vue.component('overlay-empty', () => import('@/components/AppBaseComponents/OverlayEmpty.vue'))
Vue.component('overlay-error', () => import('@/components/AppBaseComponents/OverlayError.vue'))
Vue.component('overlay-loading', () => import('@/components/AppBaseComponents/OverlayLoading.vue'))
